import { PropsWithChildren } from "react";


export default function BottomCard({children}: PropsWithChildren<any>) {
  return (
    <div className={`bottomCardContainer`}>
      <div className={`bottomCardBorder gradientBorder`}>
        <div className={`bottomCard gradientBackground`}>
            {children}
        </div>
      </div>
    </div>
  );
}
